export default {
  text: {
    en: 'New fragrance <br/>recommendations!',
  },
}
